import { api_url } from "../../../utils";

const FlujosInternos = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=viajes_internos&schema_city=",
    zindex: 3,
    type: "graduated",
    popup: {
        default: {
            content: {
                es: { flujo_int: "" },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.FlujosInternos",
    style: {
        regular: false,
        fillColor: "red",
        strokeColor: "red",
        strokeWidth: 1,
        strokeLineDash: [],
        points: 0,
        radius: 1,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.FlujosInternos.title",
            subtitle: "",
            attribute: "flujo_int",
            symbol: "point",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(213, 226, 234)",
                    strokeColor: "rgb(21, 96, 130)",
                    strokeWidth: 1,
                    radius: 4,
                    min: 5000,
                    max: 19999,
                    label: "Mobility Indicators Content.layersLegend.FlujosInternos.classes.1",
                    customCssClass:
                        "map-legend-symbol-8px map-legend-symbol-point-border-1px-21-96-130",
                },
                {
                    fillColor: "rgb(213, 226, 234)",
                    strokeColor: "rgb(21, 96, 130)",
                    strokeWidth: 1,
                    radius: 7,
                    min: 20000,
                    max: 49999,
                    label: "Mobility Indicators Content.layersLegend.FlujosInternos.classes.2",
                    customCssClass:
                        "map-legend-symbol-14px map-legend-symbol-point-border-1px-21-96-130",
                },
                {
                    fillColor: "rgb(213, 226, 234)",
                    strokeColor: "rgb(21, 96, 130)",
                    strokeWidth: 1,
                    radius: 10,
                    min: 50000,
                    max: 69999,
                    label: "Mobility Indicators Content.layersLegend.FlujosInternos.classes.3",
                    customCssClass:
                        "map-legend-symbol-19px map-legend-symbol-point-border-1px-21-96-130",
                },
                {
                    fillColor: "rgb(213, 226, 234)",
                    strokeColor: "rgb(21, 96, 130)",
                    strokeWidth: 1,
                    radius: 13,
                    min: 70000,
                    max: 89999,
                    label: "Mobility Indicators Content.layersLegend.FlujosInternos.classes.4",
                    customCssClass:
                        "map-legend-symbol-24px map-legend-symbol-point-border-1px-21-96-130",
                },
                {
                    fillColor: "rgb(213, 226, 234)",
                    strokeColor: "rgb(21, 96, 130)",
                    strokeWidth: 1,
                    radius: 16,
                    min: 90000,
                    max: 109304,
                    label: "Mobility Indicators Content.layersLegend.FlujosInternos.classes.5",
                    customCssClass:
                        "map-legend-symbol-28px map-legend-symbol-point-border-1px-21-96-130",
                },
            ],
        },
    },
};

export default FlujosInternos;
